<template>
  <activity-header data-test-path="header-bar">
    <header-row>
      <slot name="primaryButton">
      </slot>
      <slot name="editSave" v-if="showSaveEdit">
        <edit-save-button
            ref="editSaveButton"
            :save-edit-mode="saveEditMode"
            :form="form ? form.formConfig :null"
            :editEnabled="editEnabled"
            @edit="clickEdit"
            :saveEnabled="saveEnabled"
            @save="clickSave">
        </edit-save-button>
      </slot>
      <b-button v-if="form && form.formConfig.formClass === 'OrderDetails'" class="bg-primary text-light m-1"
                style="height: 38px !important;" @click="openBranding">
        <font-awesome-icon icon="tag"></font-awesome-icon> <span class="no-text">{{$tr('brandingSettings', 'Branding Settings')}}</span>
      </b-button>
      <b-btn v-if="showHistory && saveEditMode === 'SAVE'" @click="showAuditLog"
             variant="plm-toolbar-secondary" class="m-1" style="width: 42px">
        <font-awesome-icon icon="history"></font-awesome-icon>
      </b-btn>
      <AttachmentsButton
          v-if="saveEditMode === 'SAVE' && attachmentsEnabled"
          :entityInstance="entityInstance"
          :attachmentsList="attachmentsList"
          :readOnlyMode="readOnlyMode"
          :form="form"
      ></AttachmentsButton>
      <GalleryButton
          v-if="galleryEnabled"
          :entityInstance="entityInstance"
          :listOfImagesInGalleryCard="listOfImagesInGalleryCard"
          :form="form"
          :validatedField="validatedField"
          @updateGalleryRenderer="updateGalleryRenderer"
      ></GalleryButton>
      <ProductDisplayButton
          v-if="(galleryEnabled || entityInstanceFromMasterClass) && !isMobile"
          @show-product-picture="showProductPicture"
      ></ProductDisplayButton>
      <PrestaIntegrationSyncButton
          v-if="prestaShopIntegration"
          :entityInstance="entityInstance"
          :form="form"
          :validatedField="validatedField"
      ></PrestaIntegrationSyncButton>

      <SubiektIntegrationSyncButton
          v-if="subiektIntegration"
          :entityInstance="entityInstance"
          :form="form"
          :validatedField="validatedField"
      ></SubiektIntegrationSyncButton>

      <!--      <CameraButton
                v-if="saveEditMode === 'SAVE' && galleryEnabled"
            ></CameraButton>-->
      <slot name="toolButtons">
        <headers-button-group>
          <slot name="toolButton3">

            <!--              <b-btn variant="plm-toolbar-secondary" >-->
            <!--                <font-awesome-icon :icon="['fad', 'line-columns']" />-->
            <!--              </b-btn>-->
          </slot>
        </headers-button-group>
      </slot>


      <b-col cols="" class="pb-1" style="overflow: hidden"  ref="filler">
      </b-col>

      <footer-button class="col-auto pt-1 pl-0 pl-sm-1 pr-1 grid-btn-h" type="Delete" label-break-point="sm"
                     v-if="showDelete" :disabled="!deleteEnabled" @delete="clickDelete"></footer-button>
      <slot name="dangerButton">
      </slot>
      <b-col v-if="toolbox" cols="auto pt-1 pl-0 pr-1">
        <side-menu-toggle ref="sideMenuToggle" :toolbox="toolbox" :downloading-branding-zip="downloadingBrandingZip">
        </side-menu-toggle>
      </b-col>
    </header-row>
    <slot name="additionalHeaderRows"></slot>

  </activity-header>
</template>

<script>
import SideMenuButton from "@/components/navbar/SideMenuButton";
import FooterButton from "@/components/navbar/FooterButton";
import SideMenuToggle from "@/components/navbar/SideMenuToggle";
import ActivityHeader from "@/components/layout/ActivityHeader";
import HeaderRow from "@/components/layout/HeaderRow";
import EditSaveButton from "@/components/layout/EditSaveButton";
import HeadersButtonGroup from "@/components/layout/HeaderButtonsGroup";
import AttachmentsButton from "@/components/inputs/AttachmentsButton.vue";
import GalleryButton from "@/components/inputs/GalleryButton.vue";
import ProductDisplayButton from "@/components/inputs/ProductDisplayButton.vue";
import CameraButton from "@/components/inputs/CameraButton.vue";
import Perms from "@/server/Perms";
import PermissionsSet from "@/server/PermissionsSet";
import ProductInSeason from "@/server/com/silkplm/model/plm/ProductInSeason";
import FormsLoader from "@/components/forms/FormsLoader";
import ProductWCLElements from "@/server/com/silkplm/model/plm/ProductWCLElements";
import PrestaIntegrationSyncButton from "@/components/inputs/PrestaIntegrationSyncButton.vue";
import SubiektIntegrationSyncButton from "@/components/inputs/SubiektIntegrationSyncButton.vue";
import SessionManager from "@/utils/SessionManager";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";
import Tranche from "@/server/com/silkplm/model/plm/Tranche";

export default {
  name: "FormHeader",
  components: {
    PrestaIntegrationSyncButton,
    SubiektIntegrationSyncButton,
    HeadersButtonGroup,
    EditSaveButton, HeaderRow,
    ActivityHeader, SideMenuToggle,
    FooterButton, SideMenuButton,
    AttachmentsButton, GalleryButton,
    CameraButton, ProductDisplayButton
  },
  mounted() {
    this.filler = this.$refs.filler;
    if (this.toolbox) {
      this.$refs.sideMenuToggle.connectFillerBox(this.filler);
    }
    window.addEventListener('resize', this.checkIsMobile);
    this.checkIsMobile();

    this.validatedField = this.form && this.form.validatedFieldsByName.get("gallery");

    if(SessionManager.hasFlag(FeatureFlag.PRESTASHOP_INTEGRATION) && this.form !== null &&
        this.form.formConfig.formClassLong === ProductInSeason.getRemoteClass()){
      this.prestaShopIntegration = true;
    }

    if(SessionManager.hasFlag(FeatureFlag.SUBIEKT_INTEGRATION) && this.form !== null &&
        this.form.formConfig.formClassLong === Tranche.getRemoteClass()){
      this.subiektIntegration = true;
    }
  },
  methods: {

    updateGalleryRenderer(result) {
      this.$emit('triggerUpdateGalleryRenderer', result);
    },

    checkIsMobile() {
      const isMobile = window.matchMedia('(max-width: 1100px)').matches;
      this.isMobile = isMobile;
    },

    showOrHideButtons(enabled, lookForAttachments, lookForGallery, lookForEntityInstanceFromMasterClass) {
      if (lookForAttachments) {
        this.attachmentsEnabled = enabled;
      }
      if (lookForGallery) {
        this.galleryEnabled = enabled;
      }
      if (lookForEntityInstanceFromMasterClass && lookForEntityInstanceFromMasterClass.gallery) {
        this.entityInstanceFromMasterClass = enabled;
      }
    },

    clickEdit() {
      this.$emit("edit");
    },

    showProductPicture() {
      this.$emit("show-product-picture");
    },

    clickSave() {
      this.$emit("save");
    },

    clickDelete() {
      this.$emit("delete");
    },

    pinStickyNote() {
      this.$emit("pin-sticky-note");
    },
    async openBranding() {
      let product = new ProductInSeason();
      await product.load(this.form.fields["productInSeasonId"].value);
      let wcl = await product.getProductWCLElements();
      await FormsLoader.showForm(ProductWCLElements, {
        mode: 'EDIT',
        entityId: wcl.id})
    },
    showAuditLog() {
      this.$emit("show-audit-log");
    },

  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkIsMobile);
  },
  watch: {
    entityInstance: function (val) {
      this.visibility = this.entityInstance?.__supplement__?.translationInProgress;
    },
    downloadingBrandingZip: function (val) {
      this.$emit("update:downloadingBrandingZip", this.downloadingBrandingZip);
    },
  },
  props: {
    translationsEnabled: {type: Boolean, default: false},
    interfaceTranslationsEnabled: {type: Boolean, default: false},
    showSaveEdit: {type: Boolean, default: true},
    showToolbox: {type: Boolean, default: false},
    showDelete: {type: Boolean, default: false},
    downloadingBrandingZip: {default: false},

    deleteEnabled: {type: Boolean, default: false},

    editEnabled: {type: Boolean, default: true},
    saveEnabled: {type: Boolean, default: true},

    saveEditMode: {default: 'EDIT'},
    toolbox: {default: null},
    showStickyNote: {default: false},
    showHistory: {default: true},
    entityInstance: {default: null},
    imagesList: {default: null},
    listOfImagesInGalleryCard: {default: null},
    form: {default: null},
    attachmentsList: {default: null},
    readOnlyMode: {default: null},
    detailsConfig: {default: null},
    masterId: {default: null},
    mode: {default: null},
  },
  data: function () {
    return {
      lastInterfaceLanguage: AppTranslations.selectedLang,
      lastRegion: 'def',
      flag: 'def',
      flagType: 'def',
      showRightMenu: !!this.toolbox,
      permissions: new PermissionsSet(),
      attachmentsEnabled: false,
      galleryEnabled: false,
      isMobile: false,
      validatedField: null,
      entityInstanceFromMasterClass: false,
      visibility: false,
      prestaShopIntegration: false,
      subiektIntegration: false,
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 575px){
  .no-text {
    display: none;
  }
}
</style>
